import '@material/web/textfield/filled-text-field.js'
import '@material/web/button/text-button.js'
import '@material/web/select/filled-select.js'
import '@material/web/select/select-option.js'
import '../ox-board-template-list.js'

import { css, html, LitElement } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'

import { i18next, localize } from '@operato/i18n'
import { OxBoardTemplateList } from '../ox-board-template-list.js'

@customElement('board-creation-popup')
export class BoardCreationPopup extends localize(i18next)(LitElement) {
  static get styles() {
    return [
      css`
        :host {
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 10px;

          background-color: var(--md-sys-color-surface);
        }

        [body] {
          flex: 1;

          display: flex;
          flex-direction: row;
          gap: 10px;

          overflow: hidden;
        }

        [content] {
          flex: 1;

          display: flex;
          flex-direction: column;
          gap: 10px;

          overflow: auto;
        }

        [content] > md-filled-text-field[type='textarea'] {
          flex: 1;
          resize: none;
        }

        [templates] {
          flex: 2;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        [templates] > ox-board-template-list {
          flex: 1;
          overflow: hidden;
        }

        md-text-button {
          --_container-color: var(--md-sys-color-primary);
          --_label-text-color: var(--md-sys-color-on-primary);
        }
      `
    ]
  }

  @property({ type: String }) defaultGroup?: string
  @property({ type: Array }) groups?: { id: string; name: string }[]

  @query('ox-board-template-list') boardTemplateList!: OxBoardTemplateList

  render() {
    var groups = this.groups || []

    return html`
      <div body>
        <div content>
          <md-filled-text-field
            label=${String(i18next.t('label.name'))}
            name="name"
            required
            field-name
          ></md-filled-text-field>
          <md-filled-text-field
            type="textarea"
            label=${String(i18next.t('label.description'))}
            name="description"
            field-description
          ></md-filled-text-field>
          <md-filled-select
            label=${String(i18next.t('label.group'))}
            field-group
            helper="If there is no group to choose, you can leave it empty."
          >
            ${groups.map(
              group => html`
                <md-select-option value=${group.id} ?selected=${this.defaultGroup == group.id}
                  >${group.name}</md-select-option
                >
              `
            )}
          </md-filled-select>
        </div>

        <div templates>
          <div>${i18next.t('label.board-template')}</div>
          <ox-board-template-list></ox-board-template-list>
        </div>
      </div>

      <md-text-button @click=${(e: MouseEvent) => this.onClickSubmit()}
        >${String(i18next.t('button.create'))}</md-text-button
      >
    `
  }

  firstUpdated() {
    setTimeout(() => {
      ;(this.renderRoot.querySelector('md-filled-text-field') as any)?.focus()
    }, 100)
  }

  async onClickSubmit() {
    var [name, description, groupId] = ['name', 'description', 'group'].map(attr => {
      return (this.renderRoot.querySelector(`[field-${attr}]`) as any)?.value
    })

    if (!name) {
      return
    }

    const template = await this.boardTemplateList.getSelected()

    this.dispatchEvent(
      new CustomEvent('create-board', {
        detail: {
          name,
          description,
          groupId,
          model: template?.model,
          thumbnail: template?.thumbnail
        }
      })
    )
  }
}
